import {
  FETCH_ASSETS,
  FETCH_ASSETS_FAILURE,
  FETCH_ASSETS_SUCCESS,
  RESET_FETCH_ASSETS,
} from "./assetsTypes";

const initialState = {
  familyOffer: {},
  memberBenefit: {},
  specialOffer: {},
  registerCard: {},
};

const assetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ASSETS:
      return {
        ...state,
      };
    case FETCH_ASSETS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case FETCH_ASSETS_FAILURE:
      return {
        ...state,
      };
    case RESET_FETCH_ASSETS:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};

export default assetsReducer;
